import { cn } from '@virginexperiencedays/tailwind';

import { Button, type ButtonProps } from '../../../layout/Button';

export type AddToBasketProps = {
  disabled: boolean;
  error?: boolean;
  className?: string;
  onClick: () => void;
};

export const AddToBasket = ({ className, onClick, disabled, error }: AddToBasketProps) => {
  const buttonData = (
    disabled: boolean,
    error?: boolean
  ): { variant: ButtonProps['variant']; text: string } => {
    if (disabled) return { variant: 'default', text: 'sold out' };
    if (error) return { variant: 'invisible', text: 'something went wrong' };
    return { variant: 'primary', text: 'add to basket' };
  };

  return (
    <Button
      variant={buttonData(disabled, error).variant}
      fullWidth
      data-testid="add-basket-button"
      onClick={onClick}
      size="large"
      disabled={disabled}
      className={cn(
        'ml-2 px-2 capitalize md:ml-4',
        disabled && 'bg-background-disabled hover:bg-background-disabled',
        className
      )}
    >
      {buttonData(disabled, error).text}
    </Button>
  );
};
